export default __webpack_public_path__ + "static/media/rejoindre1.36cde76e.png";